const productIdsToModify = window.freeGiftProductIds;
const threshold = window.freeGiftThreshold;
let previousCartSubtotal = 0;

function fetchCart() {
  return fetch('/cart.js').then(response => response.json());
}

function clickRemoveButton(lineItemKey) {
  const removeButton = document.querySelector(`a[href*="${lineItemKey}"]`);
  if (removeButton) removeButton.click();
}

// Toggle visibility of checkout and alert buttons
function updateGwpButtonVisibility(cartSubtotal, gwpLineItem) {
  const checkoutDiv = document.querySelector('.gwp_checkout_button');
  const alertDiv = document.querySelector('.gwp_alert_button');

  if (cartSubtotal < threshold) {
    if (checkoutDiv) checkoutDiv.style.setProperty('display', 'block', 'important');
    if (alertDiv) alertDiv.style.setProperty('display', 'none', 'important');
  } else {
    if (gwpLineItem) {
      if (checkoutDiv) checkoutDiv.style.setProperty('display', 'block', 'important');
      if (alertDiv) alertDiv.style.setProperty('display', 'none', 'important');
    } else {
      if (checkoutDiv) checkoutDiv.style.setProperty('display', 'none', 'important');
      if (alertDiv) alertDiv.style.setProperty('display', 'block', 'important');
    }
  }
}

function handleCartUpdate() {
  setTimeout(() => {
    fetchCart().then(cart => {
      // Sum all non-GWP items based on final_line_price (already includes item-level discounts)
      const cartSubtotalExcludingGwp = cart.items
        .filter(item => !productIdsToModify.includes(item.product_id))
        .reduce((sum, item) => sum + item.final_line_price, 0) / 100; // convert cents to dollars

      console.log('Current Cart subtotal (excluding GWP):', cartSubtotalExcludingGwp);

      const gwpLineItem = cart.items.find(item => productIdsToModify.includes(item.product_id));

      if (cartSubtotalExcludingGwp < threshold && gwpLineItem) {
        clickRemoveButton(gwpLineItem.key);
      }

      updateGwpButtonVisibility(cartSubtotalExcludingGwp, gwpLineItem);
      previousCartSubtotal = cartSubtotalExcludingGwp;
    });
  }, 120);
}

// Handle confirm UI inside .gwp_alert_button
document.addEventListener('click', function(e) {
  const alertBtn = e.target.closest('.gwp_alert_button');
  if (alertBtn) {
    const confirmBlock = document.querySelector('.gwp_confirm_block');
    if (confirmBlock) {
      confirmBlock.style.display = 'block';
      const innerButton = alertBtn.querySelector('button');
      if (innerButton) {
        innerButton.style.opacity = '0.5';
        innerButton.style.pointerEvents = 'none';
      }
    }
  }
});

// Handle "no thanks" decline link
document.addEventListener('click', function(e) {
  const declineLink = e.target.closest('#gwp_decline_link');
  if (declineLink) {
    e.preventDefault();
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'GWP Declined': 'true' } })
    })
    .then(response => response.json())
    .then(() => {
      const alertDiv = document.querySelector('.gwp_alert_button');
      const checkoutDiv = document.querySelector('.gwp_checkout_button');
      if (alertDiv) alertDiv.style.setProperty('display', 'none', 'important');
      if (checkoutDiv) checkoutDiv.style.setProperty('display', 'block', 'important');
    });
  }
});

// On load: start monitoring cart changes
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('cart:change', handleCartUpdate);
  handleCartUpdate();
});